;(function(Backbone, EG, _) {
  'use strict';

  EG.Users.Models.CreateUser = EG.Users.Models.Base.extend({
    url: function() {
      return  (EG.Users.Utils.getDomainBasedOnConfig('POST /v3/users?company_id={company_id}&send_welcome_email={send_welcome_email}')
          && this.userType !== 'guest' ? '/global-user-service'
              : EG.Users.Constants.user_service_domain_name)
          + '/v3/users?company_id=' + this.companyId + '&send_welcome_email=' + this.get('send_welcome_email');
    },
    initialize: function(attrs, options) {

      this.userType = options && options.userType ? options.userType : 'NORMAL';
      if (options && options.inviteType) {
        this.inviteType = options.inviteType;
      }
      this.setDefaults();
    },
    resetData: function() {
       this.setDefaults();
    },
    getDefaults: function() {
      var defaults = EG.Users.Constants.user_defaults;
      if( this.inviteType===EG.Users.Constants.SelfRegistrationInvite.types.companyLink ){
        defaults = EG.Users.Constants.company_user_defaults;
      }
      if (EG.Users.Utils.isGuestUser(this.userType)) {
        defaults = EG.Users.Constants.guest_user_defaults;
      }
      if (this.inviteType === EG.Users.Constants.SelfRegistrationInvite.types.userEmail) {

        // This would be normal traveler always. Legacy Guests Can be invited through USER_SPECIFIC_INVITATION
        defaults['status_code'] = EG.Users.Profile.Constants.USER_STATUS.pending.value;

        if (EG.Users.Utils.isGlobalGuestUserType(EG.Users.Constants.user_type)) {
          defaults['type'] = 'GLOBAL_GUEST';
          defaults['status_code'] = EG.Users.Profile.Constants.USER_STATUS.active.value;
        }
      }
     return defaults;
    },
    setDefaults: function(){
      this.set(this.getDefaults());
    },
    setCompanyId: function(companyId) {
      this.companyId = companyId;
    },
    setInviteType: function(type) {
      this.inviteType = type;
    },
    setFirstName: function(value) {
      this.set('first_name', value);
    },
    setLastName: function(value) {
      this.set('last_name', value);
    },
    setGenderCode: function(value) {
      this.set('gender_code', value);
    },
    setUserGenderCode: function() {
      this.set('user_gender_code');
    },
    setSelectedUserTitleCode: function() {
      this.set('user_title_code');
    },
    setStatus: function(statusLevel) {
      this.set('status_code', statusLevel);
    },
    setInviteCode: function(inviteCode) {
      this.set('invite_code', inviteCode);
    },
    setCaptchaToken: function(captchaToken) {
      this.set('nucaptcha_token', captchaToken);
    },
    setCaptchaAnswer: function(captchaAnswer) {
      this.set('nucaptcha_answer', captchaAnswer);
    },
    setUserInvitationType: function(userInvitationType){
      this.set('invite_type', userInvitationType);
    },
    getFirstName: function() {
      return this.get('first_name');
    },
    getLastName: function() {
      return this.get('last_name');
    },
    getGenderCode: function() {
      return this.get('gender_code');
    },
    getSelectedTitleCode: function() {
      return this.get('personal_title_code');
    },
    getUserGenderCode: function() {
      return this.get('user_gender_code');
    },
    getSelectedUserTitleCode: function() {
      return this.get('user_title_code');
    },
    getWelcomeEmailLocale: function() {
      return this.get('email_locale');
    },
    setUserType: function(userType) {
      this.set('type', userType);
    },
    setDOB: function(dateOfBirth) {
      this.set('date_of_birth', dateOfBirth);
    },
    validation: {
      number: [{ validatePhone: true, msg: 'userInfo_validation_phone_invalid' }],
      single_sign_on_id: [{ isInvalid: true, msg: 'create_user_single_sign_on_id_required' }]
    },
    saveData: function(headers) {
      var updateDeferred, attrs, self;

      updateDeferred = $.Deferred();
      self = this;

      if (this.hasChanged()) {
        updateDeferred = $.Deferred();
        attrs = this.toJSON(true);
        this.save(attrs, {
          beforeSend : function (xhr) {
             if(headers && headers.USER_MGMT_META){
                  xhr.setRequestHeader('USER_MGMT_META', JSON.stringify(headers.USER_MGMT_META));
             }
          },
          success: function(data, response) {
            updateDeferred.resolve(response);
          },
          error: function(data, response) {
            updateDeferred.reject(response);
            var errorMsg = EG.Users.Constants.KIBANA_ERROR_MESSAGE_FOR_SAVE;

            errorMsg = errorMsg.replace('{Module}', 'Create User');
            errorMsg = errorMsg.replace('{component}', 'User info');
            errorMsg = errorMsg.replace('{response}', response);
            errorMsg = errorMsg.replace('{url}', self.url());

            uitk.logger.error(errorMsg);
          }
        });
      };
      return updateDeferred.promise();
    },
    saveSelfRegistration: function() {
      var url;

      url = '/users/pb/self-registration';
      var queryParam = '?company_id='+this.companyId;

      if(EG.Users.Constants.creation_channel != null){
         queryParam = queryParam + '&channel='+EG.Users.Constants.creation_channel;
                                   }
      if(EG.Users.Constants.initiator_tuid != null){
         queryParam = queryParam +'&initiator_tuid='+EG.Users.Constants.initiator_tuid;
      }

      if (this.inviteType === EG.Users.Constants.SelfRegistrationInvite.types.companyLink) {
        url = '/users/pb/company/self-registration';
      }

      this.url = function() {
        return url + queryParam;
      };

      return this.saveData();
    }
  });

})(Backbone, EG, _);
